import ApiService from './api.service'
const MahallaRequestService = {
  GetList(data) {
    return ApiService.post(`/MahallaRequest/GetList`, data);
  },
   Get(id) {
    if (id == 0 || id == undefined || id == null || id == "") {
      return ApiService.get(`/MahallaRequest/Get`);
    }
    return ApiService.get(`/MahallaRequest/Get/${id}`);
  },
  Create(data) {
    return ApiService.post(`/MahallaRequest/Create`, data);
  },
  UploadFile(file) {
    const fd = new FormData();
    fd.append("files", file);
    return ApiService.formData(`/MahallaRequest/UploadFile`, fd);
  },
  DownloadFile(fileId) {
    return ApiService.print(`/MahallaRequest/DownloadFile/${fileId}`);
  },
  DeleteFile(fileId) {
    return ApiService.post(`/MahallaRequest/DeleteFile/${fileId}`);
  },
};
export default MahallaRequestService